export default __webpack_public_path__ + "static/media/eclipse1.4b14541a.svg";